export default function LoginPageContainer({ children }) {
  return (
    <div className='tw-flex tw-items-center tw-justify-center tw-h-full tw-overflow-y-auto'>
      {children}
    </div>
  );
}
